// extracted by mini-css-extract-plugin
module.exports = {"title":"title___VTCiM","NewVirtualKds":"NewVirtualKds___23sQN"};